module.exports = __webpack_public_path__ + "static/media/star-big-06.3c0842cb.svg";